import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'acitivty',
      component: () => import('@/h5/views/activity.vue')
    },
    {
      path: '/user-return',
      name: 'userReturn',
      component: () => import('@/h5/views/userReturn/index.vue')
    },
    {
      path: '/summer-wish',
      name: 'summerWish',
      component: () => import('@/h5/views/summerWish/index.vue')
    },
    {
      path: '/summer-wish/lottery',
      name: 'summerWishLottery',
      component: () => import('@/h5/views/summerWish/lottery.vue')
    },
    {
      path: '/cp-travel',
      name: 'cpTravel',
      component: () => import('@/h5/views/cpTravel/index.vue')
    },
    {
      path: '/family-party',
      name: 'familyParty',
      component: () => import('@/h5/views/familyParty/index.vue')
    }
  ]
})

export default router
